<template>
  <UIDropdownActions :data placement="bottom-start">
    <template #default="{ toggle }">
      <UIButton
        v-bind="{ size }"
        :leading="ArrowUpTrayIcon"
        label="Export"
        variant="gray"
        fill="light"
        hide-label-to-sm
        @click="toggle"
      />
    </template>
  </UIDropdownActions>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { ButtonSize } from '@types'

import { ArrowUpTrayIcon } from '@heroicons/vue/24/outline'

import { UIButton } from '@ui/buttons'
import { UIDropdownActions } from '@ui/dropdowns'

type Props = {
  hasFilters?: boolean
  hasSelectedItems?: boolean
}
const { hasFilters = false, hasSelectedItems = false } = defineProps<Props>()

type Emits = {
  'export:all': []
  'export:filtered': []
  'export:selected': []
}
const emit = defineEmits<Emits>()

const size = inject<ButtonSize>('size')

const data = computed(() => [
  {
    label: 'Export All',
    action: () => {
      emit('export:all')
    },
  },
  {
    label: 'Export Filtered',
    disabled: !hasFilters,
    action: () => {
      emit('export:filtered')
    },
  },
  {
    label: 'Export Selected',
    disabled: !hasSelectedItems,
    action: () => {
      emit('export:selected')
    },
  },
])
</script>
